//import 'bootstrap/dist/css/bootstrap.css';

import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { Button } from 'react-bootstrap';
import { translate } from 'react-i18next';
import WaitingModal from '../generics/WaitingModal';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import 'sweetalert/dist/sweetalert.css';
import SvgIcon from 'react-icons-kit';
import {print} from 'react-icons-kit/fa/print';
import ModalHistorico from '../generics/ModalHistorico';
import ModalIncidents from './ModalIncidents';
import {List} from 'material-ui/List';
import {eye} from 'react-icons-kit/icomoon/eye';
import moment from 'moment';
import {Typeahead} from 'react-bootstrap-typeahead';
import {pencilSquareO} from 'react-icons-kit/fa/pencilSquareO';
import ModalNotes from './modalNotes';

import {lab} from 'react-icons-kit/icomoon/lab';
import IconInc from '../../assets/icons/incident';
import ModalAnaliticalTest from './ModalAnaliticalTest';
import Fields from '../generics/fields';
import { 
	biometricsDataByOffer, biometricsOption, clinicHistory, clinicHistoryPrint, clinicHistoryValuesOffer, 
	colorClinicHistory, donationNotesByOffer, donors, formularioRender, functionalCriterial,
	 getDateHour, rejectReasons, htmlTemplates, formularioId
} from '../../libs/services';

//import CKEditor from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
const {htmlToText} = require('html-to-text');
var Config = require('../../config');
const $ = require('jquery');
var imgWidth;
var imgHeight;
var isInstalled;
const style = {
  margin: 12,
};
const lastLocation = '';
class ClinicHistory extends Component{
	constructor(props, context) {
		super(props, context);
		this.saveHC = this.saveHC.bind(this);
		this.getAnswers = this.getAnswers.bind(this);
		this.cancel = this.cancel.bind(this);
		this.getColorButtonHistory = this.getColorButtonHistory.bind(this);
		this.verifyRangesBioSV = this.verifyRangesBioSV.bind(this);
		this.generatePDF = this.generatePDF.bind(this);
		this.completed = this.completed.bind(this);
		this.printConsent = this.printConsent.bind(this);
		this.keyUpRejectionDay = this.keyUpRejectionDay.bind(this);
		this.acceptNum = this.acceptNum.bind(this);
		this.openModalNotes = this.openModalNotes.bind(this);
		this.getNotes = this.getNotes.bind(this);
		this.laboratory_print = this.laboratory_print.bind(this);
		this.openModalIncidents = this.openModalIncidents.bind(this);
		this.addAnaliticalTest = this.addAnaliticalTest.bind(this);
		this.changeCombo = this.changeCombo.bind(this);
		this.updateForm = this.updateForm.bind(this);
		this.StartSign = this.StartSign.bind(this);
		this.SignResponse = this.SignResponse.bind(this);
		this.SetValues = this.SetValues.bind(this);
		this.CheckExtension = this.CheckExtension.bind(this);
		var aux_date = new Date();
		this.state = {
			enable_print:false,
			donor_id:"",
			offers_id:"",
			categories:[],
			rejection_reasons:[],
			rejection_reason_id:"",
			rejection_days:"",
			rejection_type:"",
			clinic_history_id:"",
			multigesta:"",
			donor_signature : "",
			donor:{
				donor:{donor_number:""},
				person:{sex:"",civil_status:"",job_profile:"",scholarship:""},
				offer:{donation_type:"",extraction_type:"", donor_age:"",patient:{},national_center_name:"",patient_relationship:""},
				mpio:{},
				state:{},
				cad_phones:""
			},
			IdFormulario:"",
			donation_status:"",
			update:false,
			biometrics:[],
			sv:[],
			colorBtnHistory:"gray",
			colorStatusBar:"green",
			incidents:[],
			don_abr_rech:{},
			date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			show_group_rh:false,
			show_patient:false,
			observations:"",
			rejection_description:"",
			exist_extraction:false,
			last_donation_date:"",
			last_donation_time:"",
			today:"",
			notForm:false,
			preview_print: {},
			show_finish:false,
			DON_EDIT_REJECT_DAYS:false,
			isLoading:false,
			valoration:"",
			indice: -1,
			notes:"",
			disable_obs:false,
			staff_date: "",
			lab_color:"",
			flag_incidents:false,
			lab_add_test_from_hc:{},
			auto_print_hc:{},
			max_length_bio:"4",
			max_length_sv:"4",
			modal_notes:[],
			sections:[],
			hc_mg_message:{value:''},
			status_summary: [],
			donation_number:""
		};
	}
	CheckExtension(){
		isInstalled= document.documentElement.getAttribute('sigcapturewebextension-installed');
		return isInstalled;
			}
	StartSign()
	{      
	   var canvasObj = document.getElementById('cnv');
	   canvasObj.getContext('2d').clearRect(0, 0, canvasObj.width, canvasObj.height);
	//    document.FORM1.sigRawData.value = "Signature Raw Data: ";
	//    document.FORM1.sigImageData.value = "Signature Image Data: ";
	   imgWidth = canvasObj.width;
	   imgHeight = canvasObj.height;
	   var message = { "firstName": "", "lastName": "", "eMail": "", "location": "", "imageFormat": 1, "imageX": imgWidth, "imageY": imgHeight, "imageTransparency": false, "imageScaling": false, "maxUpScalePercent": 0.0, "rawDataFormat": "ENC", "minSigPoints": 25 };
	   document.addEventListener('SigCaptureWeb_SignResponse', this.SignResponse , false);
	   var messageData = JSON.stringify(message);
	   var element = document.createElement("SigCaptureWeb_ExtnDataElem");
	   element.setAttribute("SigCaptureWeb_MsgAttribute", messageData);
	   document.documentElement.appendChild(element);
	   var evt = document.createEvent("Events");
	   evt.initEvent("SigCaptureWeb_SignStartEvent", true, false);				
	   element.dispatchEvent(evt);		
	   
   }
   SignResponse(event)
	{
	    var str = event.target.getAttribute("SigCaptureWeb_msgAttri");
		var obj = JSON.parse(str);
	 this.SetValues(obj, imgWidth, imgHeight);
	}
	SetValues(objResponse, imageWidth, imageHeight)
	{
        var obj = JSON.parse(JSON.stringify(objResponse));
	    var ctx = document.getElementById('cnv').getContext('2d');

			if (obj.errorMsg != null && obj.errorMsg!="" && obj.errorMsg!="undefined")
			{
                alert(obj.errorMsg);
            }
            else
			{
                if (obj.isSigned)
				{
				    // document.FORM1.sigRawData.value += obj.rawData;
				    this.state.donor_signature =  obj.imageData;
					var img = new Image();
					img.onload = function () 
					{
						ctx.drawImage(img, 0, 0, imageWidth, imageHeight);
						
					}
					img.src = "data:image/png;base64," + obj.imageData;
					// this.state.donor_signature = img
					
                }
            }
    }
	async componentDidMount() {

		$(document).on('blur', '#last_donation_date', (e)=>{
			if(e.target.validationMessage !== ""){
				swal('Error', e.target.validationMessage, 'error');
				/*$('#'+e.target.id).val('')
						.attr('type', 'text')
						.attr('type', 'date');*/
				$('#'+e.target.id).addClass('error');
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});

		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		    console.log(res);
		}

		var response = await getDateHour();
		if(response !== undefined){
			var aux = response.split('|');
			this.setState({
				today:aux[0]
			});
		}
		
		this.props.waiting.handleShow('Cargando...');
		this.setState({ 
			donor_id:this.props.match.params.donor_id, 
			offers_id:this.props.match.params.offers_id,
			update:false,donation_status:"",rejection_reason:"",rejection_days:"",donor:{
			donor:{donor_number:""},
			person:{sex:"",civil_status:"",job_profile:"",scholarship:""},
			offer:{donation_type:"",extraction_type:"", donor_age:"",patient:{}},
			mpio:{},
			state:{},
			cad_phones:"",
			last_donation_date:""
		}});
		
		response = await donors(this.props.match.params.donor_id, this.props.match.params.offers_id);

		if(response !== undefined){
			console.log(response)
			await this.setState({donor:response});

			if(response.group_rh !== ""){
				await this.setState({show_group_rh:true});
			}
			if(response.donation_number !== null){
				this.setState({donation_number:response.donation_number });
			}
			if(this.state.donor.person.lookup_group!=="" && this.state.donor.person.lookup_group !== null){
				await this.setState({show_group_rh:true});
			}
			if(this.state.donor.person_patient !== null){
				await this.setState({show_patient:true});
			}


			await this.getFormulario(response.person.sex, response.donation_type_extraction_id, response.clinic_history_form_id);
			await this.getColorButtonHistory();
			await this.getColorStatusBar();
			await this.getBiometrict(response.person.sex);
			await this.getVitalSigns(response.person.sex);
		}
		
		response = await functionalCriterial('don_abr_rech');
		if(response !== undefined){
			this.setState({
				don_abr_rech: response
			});
		}

		response = await functionalCriterial('lab_add_test_from_hc');
		if(response !== undefined){
			this.setState({
				lab_add_test_from_hc: response
			});
		}

		response = await functionalCriterial('lab_preview_print');
		if(response !== undefined){
			this.setState({
				preview_print: response
			});
		}

		response = await functionalCriterial('AUTO_PRINT_HC');
		if(response !== undefined){
			this.setState({
				auto_print_hc: response
			});
		}

		response = await functionalCriterial('HC_MG_MESSAGE');
		if(response !== undefined){
			this.setState({
				hc_mg_message: response
			});
		}

		response = await functionalCriterial('DON_EDIT_REJECT_DAYS');
		if(response !== undefined){
			if (response.value === "NO") { 
				this.setState({
					DON_EDIT_REJECT_DAYS: true
				});
			} else {
				this.setState({
					DON_EDIT_REJECT_DAYS: false
				});
			}
		}
		console.log("OFFER",this.state.donor.offer.group_test);
		if (sessionStorage.getItem('don_req_grh') == 'YES' && this.state.donor.offer.group_test == null) {
			swal('Advertencia', 'Este donador no tiene asignado grupo inicial','warning');
		}
	}

	async getRejectionReasons(option){
		var response = await rejectReasons(option);
		if(response !== undefined){
			this.setState({rejection_reasons:response});
		}	
	}

	//get vital signs
	async getVitalSigns(sex){
		var response = await biometricsOption('BIO_F_SIGNOS', sex);
		if(response !== undefined){
			for (var i = 0; i < response.length; i++) {
				response[i].offer_id = this.state.offer_id;
			};

			this.setState({sv: response});

			this.getVitalSignsData();
			for(var j =0;j<response.length;j++){
				if(document.getElementById('vital_sign_'+response[j].id) !== null){
					document.getElementById('vital_sign_'+response[j].id).required = response[j].required;
				}
					
			}
		}
	}
	
	async getColorButtonHistory(){
		var response = await colorClinicHistory('button_history', this.props.match.params.offers_id);
		if(response !== undefined){
			this.setState({colorBtnHistory:response.color});
		}
	}

	async getColorStatusBar(){
		var response = await colorClinicHistory('status_bar', this.props.match.params.offers_id);
		if(response !== undefined){
			this.setState({
	    		colorStatusBar:response.color, 
	    		incidents:response.incidents, 
	    		exist_extraction:response.exist_extraction,
	    		lab_color:response.lab_color,
	    		flag_incidents: response.flag_release_incidents
	    	});

	    	var incidents_bm = '';
	    	response.bm_sv_incidents.map((b)=>{
	    		incidents_bm += '-\t'+b+'\n'
 	    	})

	    	if(response.bm_sv_incidents.length > 0){
	    		swal('Incidentes Biometría Hemática y Signos Vitales', incidents_bm);
	    	}
		}
	}

	async getVitalSignsData(){
		var response = await biometricsDataByOffer(this.props.match.params.offers_id, 'BIO_F_SIGNOS');
		if(response !== undefined){
			var values = response.values;
			  for(var i =0; i < values.length;i++){
				  if(document.getElementById('vital_sign_'+values[i].biometrics_id) !== null){
					  document.getElementById('vital_sign_'+values[i].biometrics_id).value = values[i].value !== null ? parseFloat(values[i].value) : values[i].value_text;
					  this.validateRangeSV('vital_sign_'+values[i].biometrics_id,values[i].value,null);
				  }
					  
			  }
		}
	}

	async getBiometrict (sex){
		var response = await biometricsOption('BIO_F_BIO', sex);
		if(response !== undefined){
			for (var i = 0; i < response.length; i++) {
				response[i].offer_id = this.state.offer_id;
			};
			await this.setState({biometrics: response});
	
			await this.getBiometrictsData(); 

			for(var j =0;j<response.length;j++){
				if(document.getElementById('biometric_'+response[j].id) !== null){
					document.getElementById('biometric_'+response[j].id).required = response[j].required;
				}
			}
		}
	}

	async getBiometrictsData(){
		var response = await biometricsDataByOffer(this.props.match.params.offers_id, 'BIO_F_BIO');
		if(response !== undefined){
			var values = response.values;
			for(var i =0; i < values.length;i++){
				if(document.getElementById('biometric_'+values[i].biometrics_id) !== null){
					const status_summary = {
						bio_status: "COMPLETE"
					};

					this.setState({
						status_summary: status_summary
					});

					document.getElementById('biometric_' + values[i].biometrics_id).value = values[i].value !== null ? parseFloat(values[i].value) : values[i].value_text;
					this.validateRangeBiometric('biometric_' + values[i].biometrics_id, values[i].value);
				}
					
			}
		}
	}

	async getFormulario(sex, et_id, from_id){
		var response;

		if(from_id === 0){
			response = await formularioRender(sessionStorage.getItem("health_facilities_id"), sex, true, et_id);
		}else{
			response = await formularioId(from_id, sex);
		}
		
		if(response !== undefined){
			await this.setState({categories: response.sections, IdFormulario: response.id})
			await this.getRejectionReasons("actives");
			await this.getValuesHC();
		}else{
			await this.setState({notForm:true})
		}
	}

	async getValuesHC(){
		var response = await clinicHistoryValuesOffer(this.props.match.params.offers_id);
		// console.log(response);
        this.CheckExtension();
		
		if(response !== null && response !== 'Permiso Denegado.' && response !== undefined){
			this.setState({
				valoration: response.status !== undefined && response.status !== null ?
								 response.status.status === 'DIFERIDO' || response.status.status === 'REJECT' ?
									'NO_APTO'
								: response.status.status
							: "",
				donation_status:response.status !== undefined && response.status !== null ? response.status.status : "", 
				update: response.general !== undefined && response.general !== null ? true : false,
				observations: response.general !== undefined && response.general !== null ?
								response.general.observations
							: "",
				clinic_history_id: response.general !== undefined && response.general !== null ? response.general.id :"",
				enable_print: true,
				disable_obs: response.general !== undefined && response.general !== null ? 
								response.general.observations !== "" ? true : false 
							: false,
				staff_date: '** '+response.medical_staff+'\t'+
							(response.status !== undefined && response.status !== null ?
								moment(response.status.timestamp_date).format('DD/MM/YYYY')+' '+
								moment(response.status.timestamp_time, 'HH:mm:ss').format('HH:mm')
							:response.date),
				last_donation_date: response.general !== undefined && response.general !== null ? 
										response.general.last_donation_date !== null ?
											moment(response.general.last_donation_date).format('YYYY-MM-DD')
										: ""
									: "",
				last_donation_time:response.general !== undefined && response.general !== null ? response.general.last_donation_time : "",
				multigesta:response.general !== undefined && response.general !== null ? response.general.multigesta : "",
				donor_signature: response.general !== undefined && response.general !== null ? response.general.donor_signature : ""
			});

			this.getNotes();

			if(this.state.donation_status === "REJECT" || this.state.donation_status === "DIFERIDO" || this.state.donation_status === 'NOT_RESULTS'){
				var new_date = moment(response.status.timestamp_date).add('days', parseInt(response.general.rejections_days));

				this.setState({ 
					date:new_date.format('YYYY-MM-DD'),
					rejection_reasons_id:response.general.rejection_reasons_id,
					rejection_days:parseFloat(response.general.rejections_days),
					donation_status: response.general.rejections_days === 0 || response.general.rejections_days === null ?
										'REJECT'
									: response.general.rejections_days > 0 ? 'DIFERIDO' : null,
				});				

				setTimeout(function(){
					for(var i =0; i < this.state.rejection_reasons.length;i++){
						if(parseInt(response.general.rejection_reasons_id,10) === this.state.rejection_reasons[i].id){
							this.setState({
								rejection_description:this.state.rejection_reasons[i].name,
								indice: i
							});

						}
					}

				}.bind(this), 500);
				
			}

			if(response.answers !== undefined && response.answers !== null){
				var categories = this.state.categories;
				categories.forEach((cat, i)=>{
					cat.fields.forEach((field, j)=>{
						var index = response.answers.findIndex(item => item.IdCampo === field.field_id);

						if(index !== -1){
							field.default_value = response.answers[index].Valor;
						}
					});
				});

				this.setState({categories:categories});
			}
				
		}
		this.props.waiting.handleClose();
	
	}

	async getNotes(actives = true, load = false){

		if(load){
			this.props.waiting.handleShow('Cargando...');
		}

		var response = await donationNotesByOffer(this.props.match.params.offers_id, actives);
		if(load){
			this.props.waiting.handleClose();
		}
		if(response !== undefined){
			var observa = "";
			var modal_notes = []
			response.res.map((res)=>{
				var screen = '';

				if(res.note.proces_type === 'EXTRACION'){
					screen = 'EXTRACIÓN';
				}

				if(res.note.proces_type === 'CLINIC_HISTORY'){
					screen = 'HISTORIA CLINICA';
				}

				if(res.note.proces_type === 'REGISTER'){
					screen = 'REGISTRO';
				}

				if(res.note.proces_type === 'LABORATORY'){
						screen = 'LABORATORIO';
					}

				observa += ' -- '+screen+' -- \n'+
							 '** '+res.medical_staff+'\t'+
							 moment(res.note.timestamp).format('DD/MM/YYYY HH:mm')+'\n'+
							 htmlToText(res.note.note)+'\n\n';

				modal_notes.push({
					screen: screen,
					id: res.note.id,
					user_date: res.medical_staff+' - '+moment(res.note.timestamp).format('DD/MM/YYYY HH:mm'),
					note: htmlToText(res.note.note),
					active: res.note.active
				});
			})

			this.setState({notes:observa, modal_notes: modal_notes});
		}
	}

	addDays(date, days) {
	  var result = new Date(date);
	  result.setDate(result.getDate() + days);
	  return result;
	}

	saveHC(e){
		
	// console.log(this.state.donor_signature);
		e.preventDefault();
		if(this.isValidForm()){
			var obj = {}, biometrics = [], vital_signs = [],i=0, aux={};
			
			if(this.state.rejection_days < 0){
				swal('Error', 'No se permiten periodos de rechazo negativos','error');
				return;
			}

			for (i = 0; i < this.state.biometrics.length; i++) {
				if(this.state.biometrics[i].show_in_ch){
					aux = {};
					aux.biometrics_id = this.state.biometrics[i].id;
					aux.offers_id = parseInt(this.state.offers_id,10);
					aux.value = document.getElementById('biometric_'+this.state.biometrics[i].id).value;
					if(aux.value !== ""){
						biometrics.push(aux);
					}
				}
				
				
			}

			for (i = 0; i < this.state.sv.length; i++) {
				if(this.state.sv[i].show_in_ch){
					aux = {};
					aux.biometrics_id = this.state.sv[i].id;
					aux.offers_id = this.state.offers_id;
					if (this.state.sv[i].data_type ==="BIO_D_SELECT") {
						aux.value_text = document.getElementById('vital_sign_'+this.state.sv[i].id).value;
						if(aux.value_text !== ""){
							vital_signs.push(aux);
						}
					}else{
					aux.value = document.getElementById('vital_sign_'+this.state.sv[i].id).value;
					if(aux.value !== ""){
						vital_signs.push(aux);
					}
				}
				}
			}
			//Agregar signos vitales
			obj.vital_signs = {};
			obj.vital_signs.list_data = vital_signs;
			obj.vital_signs.offers_id = parseInt(this.state.offers_id,10);
			obj.vital_signs.type = "BIO_F_SIGNOS";

			//Agregar biometricos
			obj.biometrics = {};
			obj.biometrics.list_data = biometrics;
			obj.biometrics.offers_id = parseInt(this.state.offers_id,10);
			obj.biometrics.type = "BIO_F_BIO";

			obj.ValoresDeHistoriaClinica =  this.getAnswers();
			obj.donor_id = parseInt(this.state.donor_id,10);
			obj.offers_id = parseInt(this.state.offers_id,10);
			obj.form_id = this.state.IdFormulario;
			obj.donation_status={
				offers_id:parseInt(this.state.offers_id,10),
				status:this.state.valoration !== 'NOT_RESULTS' ? this.state.donation_status : this.state.valoration
			};
			obj.observations = this.state.observations;

			var date = moment(this.state.last_donation_date);
			
			obj.last_donation_date =  this.state.last_donation_date !== "" && this.state.last_donation_date !== null && this.state.last_donation_date !== undefined? 
											date.format('MM-DD-YYYY') 
									  : "";
			
			obj.last_donation_time = this.state.last_donation_time;

			if(this.state.multigesta !== ""){
				obj.multigesta = parseInt(this.state.multigesta,10);
			}else{
				obj.multigesta = null;
			}	

			obj.donor_signature = this.state.donor_signature;
			
			if(this.state.donation_status === "REJECT" || this.state.donation_status === "DIFERIDO"){//Si el estatus es rechazado
				if(this.state.rejection_days !== "" && this.state.rejection_days !== undefined){
					
					obj.rejections_days = this.state.rejection_days;
				}else{
					obj.rejections_days = null;
				}
				obj.rejection_reasons_id = parseInt(this.state.rejection_reasons_id,10);
				obj.rejection_description = this.state.rejection_description;
			}else{//Si ha sido aceptada
				obj.rejections_days = null;
				obj.rejection_reasons_id = null;
			}if(obj.ValoresDeHistoriaClinica !== null){
				if(this.state.valoration !== 'NOT_RESULTS'){
					if(this.verifyRangesBioSV(obj)){
						this.sendHC(obj);
					}
				}else{
					this.completed(obj);
				}
			} 
		}else{
			swal('Error', 'Campos Incompletos','error');
		}
	}

	sendHC(obj){
		//Validar fecha siguiente donacion
		if((this.state.last_donation_date !== 'Invalid date' && this.state.last_donation_date !== 'Fecha inválida') && this.state.last_donation_date !== ""){
			var days = 0;
			var aux_date = new Date(this.state.last_donation_date);
			var today = new Date(moment(this.state.today, "DD-MM-YYYY"));
			if(this.state.donor.person.sex === "MUJER"){
				days = 60;
			}else{
				days = 45;
			}
			var next_donation_date = this.addDays(aux_date, days);
			
			if(today < next_donation_date){
				setTimeout(()=>{
					swal({
				        title: '¡El donador tiene menos de '+days+' días de haber donado! \n ¿Desea continuar?',
				        html:true,
				        text: "",
				        type: 'warning',
				        showCancelButton: true,
				        confirmButtonColor: '#DD6B55',
				        confirmButtonText: '¡Si, Continuar!',
				        cancelButtonText: '¡No, Cancelar!',
				        closeOnConfirm: true,
				        closeOnCancel: true,
				    }, (isConfirm)=> {
				        if (isConfirm) {
				        	this.completed(obj);
				        }else{
				        	return;
				        }
				    });
				}, 500);
					
			}else{
				this.completed(obj);
			}
		}else{
			this.completed(obj);
		}
	}

	async completed(obj){
		var id = '';
		var route = "",method_type="",msg="";
		
		if(!this.state.update){//DAR DE ALTA POST
			msg = "Historia Clínica Guardada";
		}else{//ACTUALIZAR PUT
			id = this.state.clinic_history_id;
			msg = "Historia Clínica Actualizada";
		}

		var response = await clinicHistory(id, obj, this.props.waiting);
		if(response !== undefined){
			swal('¡Buen Trabajo!', msg,'success');

			if (id === '') {
				this.setState({
					show_finish:true, 
					enable_print: true, 
					clinic_history_id:response.id
				});
			}
			else {
				this.setState({
					show_finish:true, 
					enable_print: true
				});
			}
		}else{
			notify.show('Error, No se pudo guardar','error');
		}
	}

	//Verificar si el formulario es valido
	isValidForm() {
		var ctrls = [];
   		if(this.state.valoration === 'NOT_RESULTS'){
   			const select = document.querySelector('div.conclusion');
   			ctrls = select.querySelectorAll('input, select');
   		}else{
   			ctrls = document.querySelectorAll('input,select');
   		}
		

	    let isFormValid = true;

    	 ctrls.forEach(ctrl => {
	    	if(ctrl.required){
		      	const isInputValid = this.showCtrlError(ctrl.id);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });
	   
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if(control !== null){

			if (control.value === "") {
		        if(control !== null){
		            control.classList.add('error');
		        }
				res = false;
			} else{
				if(control !== null){
					if(control.required && control.className.includes('error')){
			        	control.classList.remove('error');
			    	}
		    	}
				res = true;
			}
		}

		return res;
	}

	getAnswers(){
		var obj = {}, res =[];
		this.state.categories.forEach((cat)=>{
			cat.fields.forEach((field)=>{
				
				var obj = {
					Valor: field.default_value === null ? "" : field.default_value,
					IdCampo: field.field_id,
					IdFormulario: this.state.IdFormulario
				};

				if(field.type_name === 'Fecha'){
					if(obj.Valor.length > 0){
						var aux_date = new Date(obj.Valor.split(/\//).reverse().join('/'));
						if(aux_date.toString() === 'Invalid Date'){
							swal('Formato de fecha no válido', 'PREGUNTA => "'+field.Etiqueta+'"','error');
							return null;
						}else{
							obj.Valor = aux_date;
						}
					}
				}

				res.push(obj);
			})
		})

		return res;
	}

	handleChange = (id, name, event, index, value) => {
		var control = document.getElementById(event.target.id);

		
		if(event.target.name === 'observations'){
			if(event.target.value.length <= 2500){
				this.setState({[event.target.name]:event.target.value});		
			}
		}else{
			this.setState({[event.target.name]:event.target.value});
		}

		if(event.target.id !== null){
			
			if(event.target.value !== ""){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}else{
				control.classList.add('error');
			}
		}
	
	}

	addDays(startDate, numberOfDays) {
		return new Date(startDate.getTime() + (numberOfDays * 24 *60 * 60 * 1000));
	}

	daysBetween = function( date1, date2 ) {
		  //Get 1 day in milliseconds
		  var one_day=1000*60*60*24;

		  // Convert both dates to milliseconds
		  var date1_ms = date1.getTime();
		  var date2_ms = date2.getTime();

		  // Calculate the difference in milliseconds
		  var difference_ms = date2_ms - date1_ms;
		    
		  // Convert back to days and return
		  return Math.round(difference_ms/one_day)+1; 
	}

	calculateRefusalDays = (event) => {
		var days = this.daysBetween(new Date(), new Date(event.target.value));
		this.setState({[event.target.name]:event.target.value,rejection_days:days});
		if(days < 0){//Error
			document.getElementById(event.target.id).classList.add('error');
			swal('Error', 'No se permiten periodos de rechazo negativos','error');

		}else{
			document.getElementById(event.target.id).classList.remove('error');
		}
	}

	valorationSelected = (event) => {
		this.setState({[event.target.name]:event.target.value,rejection_reasons_id:""});

		if(event.target.value === 'NO_APTO'){
			this.getRejectionReasons('actives');
		}else{
			this.setState({donation_status: event.target.value});
		}

		if(event.target.id !== null){
			var control = document.getElementById(event.target.id);
			if(event.target.value !== ""){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}else{
				control.classList.add('error');
			}
		}
	}

	openModalHistorico(e){
		e.preventDefault();
		this.modal_historico.handleShow(this.state.donor_id, this.state.preview_print);
	}

	openModalIncidents(e){
		e.preventDefault();
		this.modal_incidents.handleShow();
	}

	//Evento de cambio en elementos formulario
	handleChangeInput = (event, index, value) => {
	    this.setState({
	      [event.target.name]: event.target.value
	    });

	    if(event.target.id !== null){
			var control = document.getElementById(event.target.id);
			if(event.target.value !== ""){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}else{
				control.classList.add('error');
			}
		}
	}

	keyUpRejectionDay(event){
    	var days = Math.round(this.state[event.target.name]);
		var new_date = this.addDays(new Date(),days);
		this.setState({ 
			date:new_date.getFullYear()+'-'+("0" + (new_date.getMonth() + 1)).slice(-2)+'-'+("0" + new_date.getDate()).slice(-2)
		});
	}

	cancel(e){
		e.preventDefault();
		setTimeout(()=>{
			if(this.props.history.location.state !== undefined){
				if(this.props.history.location.state.from.indexOf('/search_donor') !== -1){
					this.props.history.push('/search_donor/'+this.props.match.params.donor_id);
				}
			}else{
				this.props.history.goBack();
			}
		}, 500);
			
		
	}

	verifyRangesBioSV(obj){
		var warnings = [];
		var i, value="";

		//Verificar Biometricos
		for(i =0; i < this.state.biometrics.length;i++){
			if(this.state.biometrics[i].ranges_validation){
				value = parseFloat(document.getElementById('biometric_'+this.state.biometrics[i].id).value);
				if(this.state.donor.person.sex === "HOMBRE"){//Valores para hombre
					if(value < this.state.biometrics[i].low_rank_male || value > this.state.biometrics[i].high_rank_male){
						warnings.push(this.state.biometrics[i]);
					}
				}else{//Valores para mujer
					if(value < this.state.biometrics[i].low_rank_female || value > this.state.biometrics[i].high_rank_female){
						warnings.push(this.state.biometrics[i]);
					}
				}
			}
		}

		//Verificar signos vitales
		for(i =0; i < this.state.sv.length;i++){
			if(this.state.sv[i].ranges_validation){
				value = parseFloat(document.getElementById('vital_sign_'+this.state.sv[i].id).value);
				if(this.state.donor.person.sex === "HOMBRE"){//Valores para hombre
					if(value < this.state.sv[i].low_rank_male || value > this.state.sv[i].high_rank_male){
						warnings.push(this.state.sv[i]);
					}
				}else{//Valores para mujer
					if(value < this.state.sv[i].low_rank_female || value > this.state.sv[i].high_rank_female){
						warnings.push(this.state.sv[i]);
					}
				}
			}
		}


		if(warnings.length>0){
			var msg = "<div class='biometrics-error'>";
			for(i =0;i < warnings.length;i++){
				msg+="<label >"+warnings[i].name+"</label><br/>";
				msg+="<span>Hombres => Min:"+warnings[i].low_rank_male;
				msg+=" Max: "+warnings[i].high_rank_male+"</span>";
				msg+="<span> Mujeres => Min:"+warnings[i].low_rank_female;
				msg+=" Max: "+warnings[i].high_rank_female+"</span><br/><br/>";
			}
			msg += '</div>';

			
			swal({
		        title: '¡Valores Biometría Hemática y/o Signos Vitales fuera de rango! \n ¿Desea guardar?',
		        html:true,
		        text: msg,
		        type: 'warning',
		        showCancelButton: true,
		        confirmButtonColor: '#DD6B55',
		        confirmButtonText: '¡Si, Continuar!',
		        cancelButtonText: '¡No, Cancelar!',
		        closeOnConfirm: true,
		        closeOnCancel: true,
		    }, function (isConfirm) {
		        if (isConfirm) {
		        	this.sendHC(obj);
		        	return true;
		        }else{
		        	return false;
		        }
			}.bind(this));
			
			setTimeout(()=>{
				$('.biometrics-error').parent('p').css({'height':'200px', 'overflow':'scroll'})
			}, 300)
		}else{
			return true;
		}
	}

	calculateValuesBIO(e){
		var control = "";

		this.validateRangeBiometric(e.target.id, e.target.value);
		for (var i = 0; i < this.state.biometrics.length; i++) {
			if (this.state.biometrics[i].data_type === "BIO_D_CALCULATED") {
				var str = (this.state.biometrics[i].formula).split('&');
				var value = this.getTerms(str,'biometric_');
				control = document.getElementById('biometric_'+this.state.biometrics[i].id)
				
				if(value !== ""){
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
					}
					control.value = value;
					control.classList.remove('error');
				}else{
					control.classList.add('error');
					control.value = "";
				}
			};
		};
		if(e.target.value.indexOf('.') !== -1){
			this.setState({max_length_bio: "5"});
		}else{
			this.setState({max_length_bio: "4"});
		}
		if(e.target.id !== null){
			control = document.getElementById(e.target.id);
			if(e.target.value !== ""){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}else if(control.className.includes('error')){
					control.classList.remove('error');
				}
			}else{
				control.classList.add('error');
			}
		}
	}

	calculateValuesSV(e){
		var control = "";

		this.validateRangeSV(e.target.id, e.target.value);
		
		for (var i = 0; i < this.state.sv.length; i++) {
			if (this.state.sv[i].data_type === "BIO_D_CALCULATED") {
				var str = (this.state.sv[i].formula).split('&');
				
				var value = this.getTerms(str,"vital_sign_");
				
				control = document.getElementById('vital_sign_'+this.state.sv[i].id);
				

				if(value !== ""){
					/*
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
					}*/

					control.value = value;
					control.classList.remove('error');
				}else{
					control.classList.add('error');
					control.value = "";
				}
			};
		};

		if(e.target.value.indexOf('.') !== -1){
			
			this.setState({max_length_sv: "5"});
		}else{
			
			
			this.setState({max_length_sv: "4"});
		}
		if(e.target.id !== null){
			control = document.getElementById(e.target.id);
			if(e.target.value !== ""){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}else if(control.className.includes('error')){
					control.classList.remove('error');
				}
			}else{
				control.classList.add('error');
			}
		}
	}

	validateRangeBiometric(id, value){
		for(var i =0; i < this.state.biometrics.length;i++){
			if(id.toString() === 'biometric_'+this.state.biometrics[i].id.toString()){
				if(this.state.biometrics[i].ranges_validation){//Si el biometrico tiene rango de valores
					var aux = parseFloat(value);
					if(this.state.donor.person.sex === "HOMBRE"){//Valores para hombre
						//Desmarcar el color rojo del control
						if(aux >= this.state.biometrics[i].low_rank_male && aux <= this.state.biometrics[i].high_rank_male){
							document.getElementById(id).style.borderColor = "#ccc";
						}else{//Si esta fuera de rango marcar el control de color rojo
							document.getElementById(id).style.borderColor = "red";
						}
					}else{//Valores para mujer
						//Desmarcar el color rojo del control
						if(aux >= this.state.biometrics[i].low_rank_female && aux <= this.state.biometrics[i].high_rank_female){
							document.getElementById(id).style.borderColor = "#ccc";
						}else{//Si esta fuera de rango marcar el control de color rojo
							document.getElementById(id).style.borderColor = "red";
						}
					}
				}	
			}
		}
	}

	validateRangeSV(id, value){
		for(var i =0; i < this.state.sv.length;i++){

			if(id.toString() === 'vital_sign_'+this.state.sv[i].id.toString()){
				if(this.state.sv[i].ranges_validation){//Si el biometrico tiene rango de valores
					var aux = parseFloat(value);
					if(this.state.donor.person.sex === "HOMBRE"){//Valores para hombre
						//Desmarcar el color rojo del control
						if(aux >= this.state.sv[i].low_rank_male && aux <= this.state.sv[i].high_rank_male){
							document.getElementById(id).style.borderColor = "#ccc";
						}else{//Si esta fuera de rango marcar el control de color rojo
							document.getElementById(id).style.borderColor = "red";
						}
					}else{//Valores para mujer
						//Desmarcar el color rojo del control
						if(aux >= this.state.sv[i].low_rank_female && aux <= this.state.sv[i].high_rank_female){
							document.getElementById(id).style.borderColor = "#ccc";
						}else{//Si esta fuera de rango marcar el control de color rojo
							document.getElementById(id).style.borderColor = "red";
						}
					}
				}	
			}
		}
	}

	getTerms(term,type){
		var result = "";
		var formula = "";
		

		for (var i = 0; i < term.length; i++) {
			
			var id = parseFloat( term[i] );
			if (!isNaN(id)) {
					if(this.getItemValue(type+id.toString()).indexOf('.') < 0){
						
						formula = formula + this.getItemValue(type+id.toString())/100;
						console.log(formula)
					}
					else{
						formula = formula + this.getItemValue(type+id.toString());
					}
				
			}else {
				formula = formula + term[i];
			};
		};
		try{
			result =  eval(formula);
			
		}catch(e){
			//swal('Error', 'Verifique todos sus valores antes de calcular','error');
			return "";
		}

		if (!isNaN(result)) {
			return (result).toFixed(2);
		} else{
			return "";
		};
	}

	getItemValue(id){
		return document.getElementById(id).value;
	}
	
	async generatePDF(e){
		e.preventDefault();
		if(this.state.clinic_history_id !== ""){
			var response = await clinicHistoryPrint(this.state.clinic_history_id, this.props.waiting);
			if(response !== undefined){
				if(this.state.auto_print_hc.value === "NO"){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else{
					this.directPrint(response);	
				}
			}
		}
	}	

	async printConsent(e){
		e.preventDefault();
		if(this.state.clinic_history_id !== ""){
			this.props.waiting.handleShow('Imprimiendo...');
				
			var obj ={};
			obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
			obj.id = this.props.match.params.offers_id;
			
			obj.file_type = (this.state.donor.offer.extraction_type==="AFÉRESIS"||this.state.donor.offer.extraction_type==="AFERESIS") ?
								"informed_consent_af"
							: this.state.donor.offer.extraction_type==="SANGRE TOTAL" && this.state.donor.offer.donation_type !== "AUTOLOGA" ? 
								"informed_consent_st"
							: this.state.donor.offer.extraction_type === 'CÉLULAS' ?
								"informed_consent_cl"
							: this.state.donor.offer.extraction_type==="SANGRE TOTAL" && this.state.donor.offer.donation_type === "AUTOLOGA" ?
								"INFORMED_CONSENT_ST_AUTO"
							: "";
			obj.nEtiqueta = [0];

			var type = await this.props.getDocumentType(obj.file_type);

			if(type !== undefined){
				var document;
				if(type.print_type === 'template'){
					document = await this.props.printDocumentTemplate(obj, type.print_automatically);
				}else if(type.print_type === 'external'){
					document = await this.props.printDocumentExternal(obj, type.print_automatically);
				}
			}

			this.props.waiting.handleClose();
			if(document !== undefined){				
				this.setState({ show: false});			
			}
			
		}else{
			swal('¡Error!', "Primero debe guardar la Historia Clínica", 'error');
		}
	}	

	directPrint(response){
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = ()=>{
			var base64data = reader.result;  
			var aux = base64data.split(',');
			this.props.socket.send('{"Operacion":"print", "Type":"clinic_history", "File": "'+aux[1]+'"}');
		}
	}

	getAddress(item){
		//console.log(item);
		var res = "NO REGISTRADA";

		if(item.street !== "" && item.street !== null){
			res = item.street;
		}
		if (item.address !=null) {
			if(item.address.ext_num !== "" && item.address.ext_num !== null){
				res += ' No. Exterior: '+item.address.ext_num;
			}
			if(item.address.int_num !== "" && item.address.int_num !== null){
				res += ' No. Interior: '+item.address.int_num;
			}
			if(item.address.colonia !== "" && item.address.colonia !== null){
				res += ' Colonia: '+item.address.colonia;
			}
		}
		
		if(item.postal_code !== null && item.postal_code !== ""){
			res += ' C.P. '+item.postal_code;
		}
		if(item.mpio !== null){
			if(item.mpio.value_name !== null && item.mpio.value_nameval !== ""){
				res+=' '+item.mpio.value_name;
			}
		}
		
		if(item.state !== null){
			if(item.state.value_name !== null && item.state.value_name){
				res += ', '+item.state.value_name;
			}
		}

		return res;
	}

	concatGroupRH(){
		var res = "";
		if(this.state.donor.offer.group_test === null){
			if(this.state.donor.person.lookup_rh==="POSITIVO"){
				res = this.state.donor.person.lookup_group+'+'
			}else{
				res = this.state.donor.person.lookup_group+'-'
			}
		}else{
			if(this.state.donor.offer.group_test.RH==="POSITIVO"){
				res = this.state.donor.offer.group_test.group+'+'
			}else{
				res = this.state.donor.offer.group_test.group+'-'
			}
		}
		if(res.length>0){
			if(this.state.donor.offer.group_test !== null){
				if(this.state.donor.offer.group_test.lectina !== null){
					var position = 1;
					res = [res.slice(0, position), this.state.donor.offer.group_test.lectina, res.slice(position)].join('');
				}
			}
		}


		return res;
	}

	editOffer(event){
		event.preventDefault();
		
		this.props.history.push("/offers/edit/"+this.state.offers_id+"/"+this.state.donor_id+"/0/0/0/0");
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;

      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){

      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
      				if(form.elements[index + 1].getAttribute("name") !== null){
      					if(form.elements[index + 1].getAttribute("disabled") === null)
	    					form.elements[index + 1].focus();
	    			
	    				else if(form.elements[index + 1].getAttribute("disabled") === "")
	    					form.elements[index + 2].focus();
      				}else{
      					form.elements[index + 2].focus();
    				}
      			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	acceptNum(e){//Sólo números y SÓLO 1 punto decimal
		if(e.key === 'Enter'){
			this.validateInput(e);
		}else{
			// Punto = 46
			var key = e.which;
			var cadena= e.target.value
			if(cadena.indexOf('.')===-1){
				if(key <= 13 || (key >= 48 && key <= 57) || key === 46){
					return;
				}else{
					e.preventDefault();
				}
			}else{
				if(key <= 13 || (key >= 48 && key <= 57)){
					return;
				}else{
					e.preventDefault();
				}
			}
		}
	}

	handleTypeAheadChange = name => values => {

        if(values.length > 0){
        	var index = this.state.rejection_reasons.findIndex(obj => obj.id === values[0].id)

        	this.setState({
        		[name]: values[0].id,
        		donation_status: values[0].rejection_days === 0 || values[0].rejection_days === null ?
        					'REJECT'
        				: values[0].rejection_days > 0 ? 'DIFERIDO' : null,
        		indice:index,
        		rejection_days: values[0].rejection_days,
        		rejection_description:values[0].name,
        	});
        	
        	var days = Math.round(values[0].rejection_days);
			var new_date = this.addDays(new Date(),days);
			this.setState({ 
				date:new_date.getFullYear()+'-'+("0" + (new_date.getMonth() + 1)).slice(-2)+'-'+("0" + new_date.getDate()).slice(-2)
			});
        	
        }
 	}

  	openModalNotes(e){
		e.preventDefault();

		this.modal_notes.handleShow();
	}

	async laboratory_print(e, ){
		e.preventDefault();

		var response = await htmlTemplates(sessionStorage.getItem("health_facilities_id"), 'area_laboratory');
		if(response !== undefined){
			if(response.res === 0){
				swal('¡Error!', "No se ha definido ningún formato de impresión", 'error');
			}else{
				this.waiting_modal.handleShow('Imprimiendo...');
		  
				var obj ={};
				obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
				obj.id = this.state.donor.donation_id;
				obj.file_type = "area_laboratory";
				obj.nEtiqueta = [0];

				var type = await this.props.getDocumentType(obj.file_type);

				var document;
				if(type.print_type === 'template'){
					document = await this.props.printDocumentTemplate(obj, type.print_automatically);
				}else if(type.print_type === 'external'){
					document = await this.props.printDocumentExternal(obj, type.print_automatically);
				}

				this.waiting_modal.handleClose();
				if(document !== undefined){					
					this.setState({ show: false});
				}
				
			}
		}
  	}

  	addAnaliticalTest(e){
  		e.preventDefault();

  		this.modal_analitical_test.handleShow(this.state.offers_id);
	}
	  
	changeCombo(e, i,form_type){
		if (form_type ==='BIO_F_SIGNOS') {
			var sv =this.state.sv;
			console.log(form_type);
			sv[i].value = e.target.value;
			this.setState({sv:sv});
		}
		if (form_type ==='BIO_F_BIO') {
			var biometrics = this.state.biometrics;
		biometrics[i].value = e.target.value;
		this.setState({biometrics: biometrics});
		}
	}

	updateForm(e, i, j){
		var categories = this.state.categories;
		
		categories[i].fields[j].default_value = e.target.value;

		this.setState({categories: categories});
	}

	render(){
		const { t } = this.props;
		return(
			<div className="col-xs-12">

				<div className="route">
					<h5 className="title_page">
					  {sessionStorage.getItem('health_facilities_name')} ->	
		              {t('sidebar.nav.donors.MAIN')} -> 
		              {t('sidebar.nav.donors.offers')} -> 
		              {t('content.modal_hc.MAIN')}
		            </h5>
		        </div>
	            <div className="col-xs-12 status-bar">
	            	<label style={{color:"black",padding:"8px"}}>Estatus</label>
	            	
					<Button className={this.state.colorStatusBar === 'red' ? "btn btn-danger col-sm-1" : 
							this.state.colorStatusBar === 'green' ? "btn btn-success col-sm-1" : "btn col-sm-1"} 
						title="Editar" style={{marginRight:'3px', float:'inherit'}} 
						onClick={(e) => this.openModalIncidents(e)}>
						<SvgIcon icon={eye} style={{paddingTop:"3px"}}/>
					</Button>
					
	            </div>
				<form id="form_hc">
		        	<div className="col-xs-12" style={{padding:"0px"}}>

		        		<div className="col-xs-12 col-sm-10"><div/>
			        		<h4 className="theme-color">{
		        				this.state.donor.person.lastname1 +' ' +
		        				this.state.donor.person.lastname2
		        				+', '+this.state.donor.person.names}
		        			</h4>
		        			<div className="col-xs-12" style={{padding:"0px"}}>
				        		<fieldset>
			        			<legend>IDENTIFICACIÓN</legend>
									<div className="col-xs-12 col-sm-2">
										<span  className="span-min">{t('content.modal_hc.offer_number')}</span>
										<input className="form-control" name="offer_id" id="offer_id" type="text" onKeyPress={(e) => this.validateInput(e)}
										disabled onChange={ this.handleChangeInput } value={this.props.match.params.offers_id}/>
									</div>	

									<div className="col-xs-12 col-sm-9">
										<span className="span-min">{t('content.modal_hc.address')}</span>
										<input className="form-control" disabled name="address" type="text" onKeyPress={(e) => this.validateInput(e)}
										value={this.getAddress(this.state.donor)} />
									</div>
									<div className="col-xs-12 col-sm-1">
										<button style={{marginTop:"19px",float:"right"}} type="button" className="btn btn-info button-min" onClick={(e)=>this.editOffer(e)}>
											EDITAR
										</button>
									</div>
									<div className="col-xs-12 col-md-1" >
										<span className="span-min" style={{fontSize:'13px'}}>{t('content.modal_hc.birthday')}</span>
										<input className="form-control" disabled name="birthday" value={moment(this.state.donor.person.birthday).format('DD/MM/YYYY')} 
										type="text" onKeyPress={(e) => this.validateInput(e)} style={{padding:'5px'}}/>
									</div>
									<div className="col-xs-12 col-md-1" >
										<span className="span-min">{t('content.modal_hc.age')}</span>
										<input className="form-control" disabled name="birthday" value={this.state.donor.offer.donor_age || ""} 
										type="text" onKeyPress={(e) => this.validateInput(e)}/>
									</div>
									<div className="col-xs-12 col-md-1" >
										<span className="span-min">{t('content.modal_hc.sex')}</span>
										<input className="form-control" disabled name="sex" value={this.state.donor.person.sex} 
										 type="text" onKeyPress={(e) => this.validateInput(e)}/>
									</div>
									<div className="col-xs-12 col-md-1" >
										<span className="span-min">{t('content.modal_hc.civil_status')}</span>
										<input className="form-control" disabled name="civil_status" value={this.state.donor.person.civil_status} 
										 type="text" onKeyPress={(e) => this.validateInput(e)} style={{padding:"5px"}}/>
									</div>
									<div className="col-xs-12 col-md-2" >
										<span className="span-min">{t('content.modal_hc.scholarship')}</span>
										<input className="form-control" disabled name="scholarship" value={this.state.donor.person.scholarship} 
										 type="text" onKeyPress={(e) => this.validateInput(e)}/>
									</div>
									<div className="col-xs-12 col-md-2" >
										<span className="span-min">{t('content.modal_hc.job_profile')}</span>
										<input className="form-control" disabled name="job_profile" value={this.state.donor.person.job_profile} 
										 type="text" onKeyPress={(e) => this.validateInput(e)}/>
									</div>
									<div className="col-xs-12 col-md-4" >
										<span className="span-min">{t('content.modal_hc.phones')}</span>
										<input className="form-control" disabled name="phones" value={this.state.donor.cad_phones} 
										 type="text" onKeyPress={(e) => this.validateInput(e)}/>
									</div>
									{this.state.show_patient?
										<div style={{padding:"0px"}}>
											<div className="col-xs-12 col-md-2" >
												<span className="span-min">{t('content.modal_hc.patient_name')}</span>
												<input className="form-control" disabled name="patient_name" value={this.state.donor.person_patient.names} 
												 type="text" onKeyPress={(e) => this.validateInput(e)}/>
											</div>
											<div className="col-xs-12 col-md-2" >
												<span className="span-min">{t('content.modal_hc.lastname1')}</span>
												<input className="form-control" disabled name="lastname1" value={this.state.donor.person_patient.lastname1} 
												 type="text" onKeyPress={(e) => this.validateInput(e)}/>
											</div>
											<div className="col-xs-12 col-md-2" >
												<span className="span-min">{t('content.modal_hc.lastname2')}</span>
												<input className="form-control" disabled name="lastname2" value={this.state.donor.person_patient.lastname2} 
												 type="text" onKeyPress={(e) => this.validateInput(e)}/>
											</div>
											<div className="col-xs-12 col-md-1" >
												<span className="span-min">{t('content.modal_hc.relationship')}</span>
												<input className="form-control" disabled name="relationship" value={this.state.donor.offer.patient_relationship} 
												 type="text" onKeyPress={(e) => this.validateInput(e)} style={{padding:'5px'}}/>
											</div>
											<div className="col-xs-12 col-md-5" >
												<span className="span-min">{t('content.modal_hc.health_facility')}</span>
												<input className="form-control" disabled name="health_facility" 
												value={this.state.donor.offer.national_center_name} 
												 type="text" onKeyPress={(e) => this.validateInput(e)}/>
											</div>
											
										</div>
									:null}
									
			        			</fieldset>

			        			<fieldset>
			        				<legend>BIOMETRÍA HEMÁTICA</legend>
			        				<List>
										{this.state.biometrics.map( (t, index) => 
											t.show_in_ch &&
												<div className="col-xs-12 col-sm-3 col-md-1" style={{padding:"2px 2px 2px 8px",overflow:"hidden"}} key={index}>
													<span className="size-min" style={{whiteSpace:"nowrap"}}>{t.name}</span>
												
													{t.data_type === 'BIO_D_SELECT' ? 
														<select name={'biometric_'+t.id} id={'biometric_'+t.id} 
															value={t.value} className="form-control"
															required={t.required}
															style={{padding:5}}
															onChange={(e)=>this.changeCombo(e, index)}
															disabled={(!this.props.task_biometrics.create && !this.props.task_biometrics.update)||
																this.state.exist_extraction}
														>
															<option value="">Seleccione...</option>
															{t.biometrics_options.map((option, i)=>
																<option value={option.value} key={i}>{option.value}</option>
															)}
														</select>
													: t.data_type === 'BIO_D_OPEN' ?
														<input 
															name={'biometric_'+t.id} 
															id={'biometric_'+t.id} 
															value={t.value} 													
															maxLength={50}
															//onKeyPress={this.acceptNum}
															onChange={(e) => this.changeCombo(e, index)}
															type="text" className="form-control"
															disabled={(!this.props.task_biometrics.create && !this.props.task_biometrics.update)||
																this.state.exist_extraction}
															required={t.required}
														/>
													:
														<input 
															disabled={this.state.disabled_element ? true :
																t.data_type === "BIO_D_CALCULATED" || 
																(!this.props.task_biometrics.create && !this.props.task_biometrics.update)||
																this.state.exist_extraction
															} 
															className="form-control bio_extraction" name={'biometric_'+t.id.toString()} 
															step="0.01" type="number" min="0" 
															maxLength="4"
															id={'biometric_'+t.id.toString()}
															onChange={(e) => this.calculateValuesBIO(e)}
															onKeyPress={(e) => this.validateInput(e)}
														/>
													}
												</div>
										)}
			        				{/*
										this.state.biometrics.map( (t, index) => (
											<div className="col-xs-12 col-sm-3 col-md-1" style={{padding:"2px 2px 2px 8px",overflow:"hidden"}} key={index}>
												<span className="size-min" style={{whiteSpace:"nowrap"}}>{t.name}</span>
											
												<input disabled={t.data_type === "BIO_D_CALCULATED" || (!this.props.task_biometrics.create && !this.props.task_biometrics.update)||this.state.exist_extraction} 
													className="form-control" name={"biometric_"+index} 
													type="text" 
													maxLength={this.state.max_length_bio}
													id={'biometric_'+t.id.toString()}
													onChange={(e) => this.calculateValuesBIO(e)}
													onKeyPress={this.acceptNum}
													required={t.required} />
											</div>
										))
										*/}
				        			</List>
			        			</fieldset>

			        			<fieldset>
			        				<legend>SIGNOS VITALES</legend>
			        				<List>
			        				{
										this.state.sv.map( (t, index) => (
											<div className="col-xs-12 col-sm-3 col-md-1" style={{padding:"2px 2px 2px 8px",overflow:"hidden"}} key={index}>
												<span className="size-min" style={{whiteSpace:"nowrap"}}>{t.name}</span>
											{t.data_type == "BIO_D_SELECT"?
											<select name={'vital_sign_'+t.id} id={'vital_sign_'+t.id} 
											value={t.value} className="form-control"
											required={t.required}
											style={{padding:5}}
											onChange={(e)=>this.changeCombo(e, index)}
											disabled={(!this.props.task_biometrics.create && !this.props.task_biometrics.update)||
												this.state.exist_extraction}
										>
											<option value="">Seleccione...</option>
											{t.biometrics_options.map((option, i)=>
												<option value={option.value} key={i}>{option.value}</option>
											)}
										</select>
										:
												<input disabled={t.data_type === "BIO_D_CALCULATED" || (!this.props.task_vital_signs.create && !this.props.task_vital_signs.update)||this.state.exist_extraction} 
													className="form-control" 
													name={"vital_sign_"+index} 
													value={t.value}
													id={'vital_sign_'+t.id}
													onKeyPress={this.acceptNum}
													maxLength={this.state.max_length_sv}
													type="text" id={'vital_sign_'+t.id.toString()}
													onChange={(e) => this.calculateValuesSV(e)}
													required={t.required} />
											}
													</div>
										))
									}
				        			</List>
			        			</fieldset>

			        			<fieldset className="col-xs-12 col-sm-3" style={{padding:"0px"}}>
			        				<legend>FECHA ÚLTIMA DONACIÓN</legend>
			        				<div className="col-xs-12 col-sm-8" style={{paddingRight:"0px", marginTop:8}}>
										<input type="date" name="last_donation_date" id="last_donation_date" className="form-control hour-input" 
											onKeyPress={(e) => this.validateInput(e)} onChange={ this.handleChange.bind(null,"id","last_donation_date")} 
											value={this.state.last_donation_date} />
									</div>
			        			</fieldset>
			        			<fieldset className="col-xs-12 col-sm-4" style={{padding:"0px"}}>
			        				<legend>TIEMPO DESDE ÚLTIMA DONACIÓN</legend>
			        				<div className="col-xs-12 col-sm-6" style={{paddingRight:"0px", marginTop:8}}>
										<input type="text" name="last_donation_time" id="last_donation_time" className="form-control" onKeyPress={(e) => this.validateInput(e)}
										onChange={ this.handleChange.bind(null,"id","last_donation_time")} value={this.state.last_donation_time}/>
									</div>
			        			</fieldset>

			        			{this.state.donor.person.sex === "MUJER"?
			        			<fieldset className="col-xs-12 col-sm-5" style={{padding:"0px"}}>
			        				<legend>{this.state.hc_mg_message.value}</legend>
			        				<div className="col-xs-12 col-sm-6 col-md-4" style={{paddingRight:"0px", marginTop:8}}>
			        					<select className="form-control" value={this.state.multigesta} required
										disabled={(!this.props.task_clinic_history.create && !this.props.task_clinic_history.update)||this.state.exist_extraction}
										onChange={ this.handleChange.bind(null,"id","multigesta") } name="multigesta" id="multigesta" onKeyPress={(e) => this.validateInput(e)}>
											<option value="" disabled >Seleccionar...</option>
											<option value="1">SÍ</option>
											<option value="0">NO</option>
										</select>
									</div>
			        			</fieldset>:null}
			        		</div>
			        	</div>
		        		<div className="col-xs-12 col-sm-2" style={{paddingTop:"5px"}}>
							<div className="col-xs-12 from-group">
								{this.state.show_group_rh?
									<div className="col-xs-12" style={{textAlign:'center'}}>
										<h2 style={{color:"#FF0000", fontWeight:'bold', marginLeft:'15%', margin:'0', fontSize:'80px', fontFamily: 'Roboto Condensed, sans-serif'}}>
											{this.state.donor.group_rh}
										</h2>
									</div>
								:null}
							</div>
		        			<div className="col-xs-12" style={{textAlign:"center",paddingLeft:"0px"}}>
		        				
								{this.state.donor.person.photo !== null && this.state.donor.person.photo !== undefined?
									<div className="col-xs-12 col-sm-10 col-sm-offset-2">
										<img style={{height:'170px',width:'164px'}} src={'data:image/jpeg;base64,'+this.state.donor.person.photo} alt="Donor"/>
									</div>
									:<div className="col-xs-12 col-sm-10 col-sm-offset-2"><img style={{height:'170px',width:'164px'}} src="../../../default_user.jpg" alt="USER"/></div>
									
								}
							</div>
							
							<div className="col-xs-12 col-sm-offset-2 col-sm-10" style={{textAlign:"center",padding:"0px"}}>
								<div className="col-xs-12">
									<span  className="span-min">{t('content.modal_hc.donation_type')}</span>
								</div>
								<div className="col-xs-12 col-sm-offset-1 col-sm-10 col-md-11" style={{paddingTop:"5px", paddingLeft:'0', paddingRight:'0'}}>
				        			<input className="form-control" name="donation_type" id="donation_type" type="text" onKeyPress={(e) => this.validateInput(e)}
				        			disabled onChange={ this.handleChangeInput } value={this.state.donor.offer.donation_type} style={{padding:'5px'}}/>
								</div>
								<div className="col-xs-12 col-sm-offset-1 col-sm-10 col-md-11" style={{paddingTop:"5px",paddingLeft:'0', paddingRight:'0'}}>
									<input className="form-control" name="extraction_type" id="extraction_type" type="text" onKeyPress={(e) => this.validateInput(e)}
									disabled onChange={ this.handleChangeInput } value={this.state.donor.offer.extraction_type}
									/>
								</div>
								<div className="col-xs-12">
									<span className="span-min">{t('content.modal_hc.donor_number')}</span>
								</div>
								<div className="col-xs-12 col-sm-offset-1 col-sm-10 col-md-11" style={{paddingTop:"5px",paddingLeft:'0', paddingRight:'0'}} >
									<input className="form-control" disabled name="donor_number" value={this.state.donor.donor.donor_number} type="text" onKeyPress={(e) => this.validateInput(e)}/>
								</div>

								
								<div style={{textAlign:"center"}} >
									<button className="btn btn-success" style={{marginTop:"5px",fontSize:".7em",backgroundColor:this.state.colorBtnHistory,border:"0px"}} 
									type="button" onClick={(e) => this.openModalHistorico(e)}>HISTORICO</button>
				        		</div>
				        		
				        		
				        	</div>
		        		</div>
		        		<div className="col-xs-12">
							{this.state.categories.map((cat, i)=>
								<fieldset key={i}>
									<legend>{cat.section_name}</legend>
									<div className='d-flex flex-wrap form-group' style={{marginTop:10}}>
										{cat.fields.map((field, j)=>
											<Fields 
												key={j} 
												{...this.props} 
												field={field} 
												section={i} 
												index={j}
												updateForm={this.updateForm}
											/>
										)}
									</div>
								</fieldset>
							)}
						
						{/*
	        			this.state.categories.map(function(t, index) {
				        	return (
				        		<fieldset key={index}>
			        			<legend>{t[0].category_name}</legend>
			        			{
		        				t.map(function(ask){
		        					return (
		        						ask.NombreTipo !== "ComboSiNo"?
		        						<div className="col-xs-12 col-md-4" style={{padding:"2px 2px 2px 8px"}} key={ask.IdCampo}>
		        							<div className="col-xs-12 col-md-8" style={{padding:"0px"}}>
		        								<span className="size-min">{ask.Etiqueta}</span>
		        							</div>
		        							<div className="col-xs-12 col-md-4" style={{paddingRight:"0px"}} >
		   
		    									{Parser(ask.html)}

		        								
		    								</div>
		    							</div>:
		    							<div className="col-xs-12 col-md-4" style={{padding:"2px 2px 2px 8px"}} key={ask.IdCampo}>
		        							<div className="col-xs-12 col-md-10" style={{padding:"0px"}}>
		        								<span className="size-min">{ask.Etiqueta}</span>
		        							</div>
		        							<div className="col-xs-12 col-md-2" style={{paddingRight:"0px"}} >
		        								
		    									{Parser(ask.html)}
		    								</div>
		    							</div>
	    							)
		        				})
			        			}
			        			</fieldset>
			        		);
				    	})*/}
	        			<fieldset>
	        				<legend>{t('content.modal_hc.observations')}</legend>
	        				<div className="col-xs-12" style={{paddingRight:"0px"}}>
	        					
	        					<label>{this.state.staff_date}</label>

	        					<textarea className="form-control" style={{height:"250px",width:"100%",resize:"none"}}
		        					value={this.state.observations+'\n\n'+this.state.notes} disabled />

		        				{!this.state.exist_extraction && !this.state.disable_obs?
		        					<textarea className="form-control-min" value={this.state.observations || ""} 
										style={{height:"15em",width:"100%",resize:"none"}}
										disabled={(!this.props.task_clinic_history.create && !this.props.task_clinic_history.update)||
											this.state.exist_extraction || this.state.disable_obs}
										onChange={ this.handleChange.bind(null,"id","observations") } 
										name="observations" id="observations"/>
	        					:null}
		        					
	        					

									
							</div>
	        			</fieldset>
		        		<fieldset>
	        			<legend>{t('content.modal_hc.conclusion')}</legend>
	        				<div className="col-xs-12 form-group conclusion">
								<div className="col-xs-12 col-md-2" style={{padding:"2px 2px 2px 8px"}}>
									
									<span className="size-min">{t('content.modal_hc.result')}</span>
									
									<select className="form-control" required value={this.state.valoration} 
									disabled={(!this.props.task_clinic_history.create && !this.props.task_clinic_history.update)||this.state.exist_extraction}
									onChange={ this.valorationSelected.bind() } name="valoration" id="valoration">
										<option value="" disabled >Seleccionar...</option>
										<option value="ACCEPT">APTO</option>
										<option value="PENDING">PENDIENTE</option>
										<option value="NO_APTO">NO APTO</option>
										<option value="NOT_RESULTS">RECHAZADO SIN VALORAR</option>
									</select>
								</div>
								{this.state.valoration === "NO_APTO"  || this.state.valoration === "NOT_RESULTS"?
									<div style={{padding:'0px'}}>
										<div className="col-xs-12 col-md-6" style={{padding:"2px 2px 2px 8px"}}>
											
											<span className="size-min">{t('content.modal_hc.rejection_reasons')}</span>
											
											{this.state.don_abr_rech.value === "NO"?
												
													<Typeahead
											          	disabled={(!this.props.task_clinic_history.create && 
															!this.props.task_clinic_history.update)||this.state.exist_extraction}
											          	labelKey={(option) => `${option.name}`}
											          	minLength={0}
											          	name="rejection_reasons_id"
											          	id="rejection_reasons_id" 
											          	inputProps={{
											          		required:this.state.don_abr_rech.value === "NO" || 
											          				this.state.valoration === 'NO_APTO' || this.state.valoration === 'NOT_RESULTS',
											          		autoComplete:"off",
											          		name:'rejection_reason',
											          		id:'rejection_reason'
											          	}}
											          	options={this.state.rejection_reasons}
											          	onChange={ this.handleTypeAheadChange('rejection_reasons_id')} 
											          	ref="_handleSearch"
											          	selected={this.state.indice !== -1 ?
												          			[this.state.rejection_reasons[this.state.indice]]
												          		: []}
												         delay={600}
												         paginationText="Mostrar mas resultados..."
											        />

											:
											
												<input className="form-control" name="rejection_description" 
												id="rejection_description" step="0.01" type="text" min="0" 
												disabled={(!this.props.task_clinic_history.create && 
													!this.props.task_clinic_history.update)||this.state.exist_extraction}
												onChange={ this.handleChangeInput } value={this.state.rejection_description} 
												required={this.state.don_abr_rech.value === "YES" 
												|| this.state.valoration === 'NO_APTO' || this.state.valoration === 'NOT_RESULTS'}/>
											
											}
										</div>
										<div className="col-xs-12 col-sm-1">
											<span className="size-min">Tipo</span>
											<input 
												className="form-control" name="donation_status" id="donation_status"
												disabled value={
													this.state.donation_status === "REJECT" ? 'PERMANENTE' : 
													this.state.donation_status === 'DIFERIDO' ? 'DIFERIDO' : ""
												}
											/>
										</div>
										{this.state.donation_status === "REJECT" && this.state.rejection_type !== "" ? 
											<div style={{padding:"0px"}}>
												<div className="col-xs-12 col-md-1" style={{padding:"2px 2px 2px 8px"}}>
													<span className="size-min">{t('content.modal_hc.rejection_type')}</span>
													<input 
														className="form-control" name="rejection_type" id="rejection_type"
														disabled value={
															this.state.rejection_type === 0 ? 'PERMANENTE' :
															this.state.rejection_type === 1 ? 'TEMPORAL' :
															this.state.rejection_type === 2 ? 'INDEFINIDO' :
															''
														}
													/>
												</div>
											</div>
											: null
										}
										{this.state.donation_status === "DIFERIDO"?
											<div style={{padding:"0px"}}>
												<div className="col-xs-12 col-md-1" style={{padding:"0"}}>
													<span className="size-min" style={{fontSize:'13px'}}>{t('content.modal_hc.rejection_days')}</span>
													<input className="form-control" name="rejection_days" id="rejection_days" step="0.01" 
														type="number" min="0" 
														disabled={ this.state.DON_EDIT_REJECT_DAYS || (this.state.DON_EDIT_REJECT_DAYS && ((!this.props.task_clinic_history.create && !this.props.task_clinic_history.update)||this.state.exist_extraction) ) }
														onChange={ this.handleChangeInput } value={this.state.rejection_days}
														onKeyUp={this.keyUpRejectionDay} 
														required={this.state.donation_status === "DIFERIDO"} />
												</div>

												<div className="col-xs-12 col-md-2" style={{padding:"0px 8px"}}>
													<span className="size-min">{t('content.modal_hc.next_donation')}</span>
													<input className="form-control hour-input" name="date" id="date" type="date" 
													disabled
													onChange={ this.calculateRefusalDays } value={this.state.date} 
													required={this.state.donation_status === "DIFERIDO"}/>
												</div>
											</div>
										
										: null}

									</div>
								:null}
							</div>
	        			</fieldset>
	        			</div>
						{/* {isInstalled === "true" ?
						<div>
						{this.state.donor_signature === null || this.state.donor_signature === "" ?
						<div>
					
						<canvas id="cnv" name="cnv" width="500" height="100"></canvas>
						<canvas name="SigImg" id="SigImg" width="500" height="100"></canvas>
						<form action="#" name="FORM1">
						<RaisedButton className="action-btn" label="Firmar" style={style} 
		        			onClick={this.StartSign}   		/> 	
						
								<input type="hidden" name="bioSigData"/>
			<input type="hidden" name="sigImgData" /*value={this.state.donor_signature} /> 
		        		</form>
	
					
						</div>
						:null}
						</div>
						:null} 
						{this.state.donor_signature !== "" ?
						<div>
							<img src={"data:image/png;base64,"  +  this.state.donor_signature}></img>
					
							 <RaisedButton className="action-btn" label="Firmar" style={style} 
		        			onClick={this.StartSign}
		        		/> 	 
							</div>
							:null}*/}
							
	        			<div className="col-xs-12" style={{textAlign:"center",fontSize:".8em",padding:'0px'}}>
							<div className="form-group" >
								<button className="toolIcon" onClick={this.generatePDF} 
									disabled={!this.state.enable_print}>
									<SvgIcon size={40} icon={print} />
									<div>
									<span>{t('toolbar.print_hc')}</span>
									</div>
								</button>

								<button className="toolIcon" onClick={this.printConsent} disabled={!this.state.enable_print}>
									<SvgIcon size={40} icon={print} />
									<div>
									<span>{t('toolbar.print_con')}</span>
									</div>
								</button>

								<button className="toolIcon" onClick={this.openModalNotes}>
									<SvgIcon size={40} icon={pencilSquareO} 
										style={this.state.notes.length > 0 ? {color:'green'} : {}} />
									<div>
										<span>{t('toolbar.save_notes')}</span>
									</div>
								</button>

								<button className="toolIcon" onClick={this.laboratory_print}
									disabled={this.state.lab_color === 'GRAY'}>
									<SvgIcon size={40} icon={lab} 
										style={{color:this.state.lab_color}} />
									<div>
										<span>Imprimir Laboratorio</span>
									</div>
								</button>

								{this.state.lab_add_test_from_hc.value !== 'NO' ?
									<button className="toolIcon" onClick={this.addAnaliticalTest}>
										<SvgIcon size={40} icon={lab}  />
										<div>
											<span>Agregar Pruebas</span>
										</div>
									</button>
								:null}

								<button className="toolIcon" onClick={this.openModalIncidents} 
									//disabled={!this.state.flag_incidents}
									style={{position:'relative', top:'14px'}}>
								 	<div>
									 	<IconInc width={40} title="Incidentes Extracción" 
									 		style={{marginTop:'5px'}}
									 		fill={!this.state.flag_incidents ? '#a9a9a9' : '#333333'} />
									</div>
									<div>
										<span>Quitar Candado</span>
									</div>
								</button>
							</div>
						</div>
					</div>
					{!this.state.show_finish?
					<div className="col-xs-12" style={{textAlign:'center'}}>
		        		<RaisedButton className="action-btn"
		        			type="submit" label={t('content.generics.buttons.save')} 
		        			style={style} onClick={this.saveHC} 
		        			disabled={this.notForm ? true :

		        				this.props.task_clinic_history.create ? this.state.exist_extraction  : 
		        				this.props.task_clinic_history.update ? this.state.exist_extraction ? true : false  : true}
		        		/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} style={style} 
		        			onClick={this.cancel}
		        		/>
					   </div>:
					   <div className="col-xs-12" style={{textAlign:'center'}}>
					   <RaisedButton className="action-btn" label={t('content.generics.buttons.finish')} style={style} 
						   onClick={this.cancel}
					   />
					  </div>}
		        </form>
		      	<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
		      	<ModalNotes {...this.props} onRef={ref => (this.modal_notes = ref)} 
		      		getNotes={this.getNotes} notes={this.state.modal_notes} donor={this.state.donor_id}/>
				<ModalHistorico {...this.props} onRef={ref => (this.modal_historico = ref)} directPrint={this.directPrint}/>
				<ModalIncidents {...this.props} onRef={ref => (this.modal_incidents = ref)} incidents={this.state.incidents}/>
		      	<Notifications />
		      	<ModalAnaliticalTest {...this.props}  onRef={ref => (this.modal_analitical_test = ref)}  />
	      	</div>
		);
	}
}

export default translate('translations')(ClinicHistory) 